import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

const ORDINALS = ["1st", "2nd", "3rd", "4th", "5th", "6th", "7th", "8th", "9th", "10th", "11th", "12th"];

export const GRADE_OPTIONS = [
  { value: "Pre-K", noun: "Pre-K Student" },
  { value: "Kindergarten", noun: "Kindergartner" },
  ...ORDINALS.map((o) => ({ value: `${o} Grade`, noun: `${o} Grader` })),
];

function gradeNoun(grade) {
  const match = GRADE_OPTIONS.find((g) => g.value.toLowerCase() === grade.toLowerCase());
  if (match) return match.noun;
  const ordinal = grade.match(/^(\d+(st|nd|rd|th))(\s*grade)?$/i);
  return ordinal ? `${ordinal[1]} Grader` : null;
}

export function testimonialByline(t) {
  const name = t.child_first_name?.trim();
  const grade = t.child_age_or_grade?.trim();
  if (name) return grade ? `Parent of ${name} · ${grade}` : `Parent of ${name}`;
  if (!grade) return "Parent";
  const noun = gradeNoun(grade);
  return noun ? `Parent of a ${noun}` : `Parent · ${grade}`;
}
